import React, { useEffect, useState} from 'react'
import { Page, Text, View, Document, StyleSheet, Image, Font} from '@react-pdf/renderer'
import AuthService from "../../api/ApiRest";
//import QRCode from "react-qr-code";
//import QRCode from 'qrcode.react';
import Fondo from "../../assets/ctm_6.png"
import {format, parseISO } from 'date-fns';
import {es} from 'date-fns/locale';
import Logo_cfc from "../../assets/logo_cfc.jpg"
import logo_experiencia from "../../assets/logo_experiencia.png"
import MiFuente from '../../assets/fonts/Arimo/static/Arimo-Regular.ttf'; // Asegúrate de la ruta correcta
import MiFuenteB from '../../assets/fonts/Arimo/static/Arimo-Bold.ttf'; // Asegúrate de la ruta correcta
import firma_director from "../../assets/firma_director.png"
import firma_psicologo from "../../assets/firma_agustin_araya.png"

Font.register({
    family: 'Arimo',
    fonts: [
        { src: MiFuente, fontWeight: 'normal' },
        { src: MiFuenteB, fontWeight: 'bold' },
      ]
  });

const EgresoPracticaPDF = ({datos}) => {
    const [curso,setCurso]=useState([]);
    const [habilitado,setHabilitado]=useState(false);
    const [director,setDirector]=useState([]);
    const [directorS,setDirectorS]=useState([]);
    const [encargado,setEncargado]=useState([]);
    useEffect(()=>{
        
        const cursoData=async()=>{
            const response= await AuthService.getCursoAlumnoId(datos);
            setCurso(response.data.body[0])
        }
        cursoData();
        const firmaData=async()=>{
            const response= await AuthService.getFirmas();
            for (let index = 0; index < response.data.body.length; index++) {
                if(response.data.body[index].habilitado==='S'){
                    setHabilitado(true)
                }else{
                    setHabilitado(false)
                }
                if(response.data.body[index].cargo==='D'){
                    setDirector(response.data.body[index])
                }
                if(response.data.body[index].cargo==='S'){
                    setDirectorS(response.data.body[index])
                }
                if(response.data.body[index].cargo==='E'){
                    setEncargado(response.data.body[index])
                }
            }
        }
        firmaData();
    },[])
    //const qrContent=JSON.stringify(curso.folio);
      /*<QRCode
        size={256}
        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        value='holamundo'
        viewBox={`0 0 256 256`}
        /> */
        
    const capitalize=(str)=>{
        return str.charAt(0).toUpperCase()+str.slice(1);
    }
    function cambiarFormatoFecha(fecha,tipo){
        const fechaISO=parseISO(fecha);
        let fechaFormateada='';
        if(tipo==='dd'){
            fechaFormateada=format(fechaISO,'dd');
        }
        if(tipo==='MM'){
            fechaFormateada=capitalize(format(fechaISO,'MMMM',{locale:es}));
        }
        if(tipo==='yyyy'){
            fechaFormateada=format(fechaISO,'yyyy');
        }
        if(tipo==='dd-MM-yyyy'){
            fechaFormateada=format(fechaISO,'dd-MM-yyyy');
        }
        return fechaFormateada;
        }
        const [qrImage, setQrImage] = useState(null);

        const handleImageGenerated = (imageDataUrl) => {
          setQrImage(imageDataUrl);
        };
    return (
        <Document>
            <Page size="LETTER" style={styles.page}>
                <View style={styles.header} fixed>
                    <Image
                        src={Fondo}
                        style={styles.fondo}
                    />
                </View>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: 0 }} fixed>
                    {/* Logo izquierdo */}
                    <Image src={Logo_cfc} style={{ width: 110, height: 70 }} />
                </View>
                <View style={styles.encabezado} fixed>
                    <Text>EX CENTRO TECNOLÓGICO MINERO</Text>
                </View>
                <View  style={styles.parrafoTitulo}>
                    <Text>EL CENTRO DE FORMACIÓN Y CAPACITACIÓN UNAP SPA, OTORGA EL PRESENTE CERTIFICADO A DON(A):</Text>
                </View>
                <View  style={styles.nombre}>
                    <Text>{curso.nombre_alumno} {curso.primer_apellido} {curso.segundo_apellido}</Text>
                    <Text>RUT {curso.run?curso.run.toLocaleString('es-ES'):null}{curso.extranjero==='N' ?'-'+curso.dv:null}</Text>
                </View>
                <View  style={styles.parrafo}>
                    <Text>Por su participación y aprobación en el curso:</Text>
                </View>
                <View style={styles.nombreCurso}>
                    <Text>{curso.nombre_curso}</Text>
                </View>
                <View  style={styles.parrafo}>
                    <Text>Obteniendo la siguiente calificación:</Text>
                </View>
                <View  style={styles.parrafo}>
                    <Text>Rendimiento Final: {curso.nota_final}%</Text>
                    <Text>Práctica Pre-Ocupacional: 100%</Text>
                </View>
                <View  style={styles.parrafo}>
                    <Text>Dictado desde {curso.fecha_inicio_curso?cambiarFormatoFecha(curso.fecha_inicio_curso.substring(0,10),'MM'):''}{curso.fecha_termino_curso?cambiarFormatoFecha(curso.fecha_inicio_curso.substring(0,10),'yyyy')===cambiarFormatoFecha(curso.fecha_termino_curso.substring(0,10),'yyyy')?'':' del '+cambiarFormatoFecha(curso.fecha_inicio_curso.substring(0,10),'yyyy'):''} hasta {curso.fecha_termino_curso?cambiarFormatoFecha(curso.fecha_termino_curso.substring(0,10),'MM'):''} del {curso.fecha_termino_curso?cambiarFormatoFecha(curso.fecha_termino_curso.substring(0,10),'yyyy'):''}</Text>
                </View>
                <View  style={styles.parrafo}>
                    <Text>Con una duración de {curso.duracion_horas} horas. La práctica Preocupacional se realizó en:</Text>
                    <Text>{curso.empresa_practica}.</Text>
                </View>
                <View  style={styles.firmas}>
                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 1 }}>
                        <Image src={firma_psicologo} style={{ width: 80, height: 80 }} />
                        <Text style={styles.nombreFirma}>AGUSTÍN ARAYA URRUTIA</Text>
                        <Text style={styles.cargoFirma}>JEFE DE PROYECTOS</Text>
                    </View>
                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 1 }}>
                        <Image src={firma_director} style={{ width: 80, height: 80 }} />
                        <Text style={styles.nombreFirma}>{directorS.habilitado==='S'?directorS.nombre?.toUpperCase()+' '+directorS.primer_apellido?.toUpperCase()+' '+directorS.segundo_apellido?.toUpperCase():director.nombre?.toUpperCase()+' '+director.primer_apellido?.toUpperCase()+' '+director.segundo_apellido?.toUpperCase()}</Text>
                        <Text style={styles.cargoFirma}>DIRECTOR</Text>
                    </View>
                </View>
                <View style={styles.piePagina} fixed>
                    <View style={{ flex: 2, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 1 }}>
                    </View>
                    <View style={{ flex: 2, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 1 }}>
                    </View>
                    <View style={{ flex: 2, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 1 }}>
                        <Image src={logo_experiencia} style={{ width: 50, height: 50 }} />  
                    </View>
                    <View style={{ flex: 2, flexDirection: 'column', justifyContent: 'space-between', textAlign: 'left', paddingHorizontal: 1, paddingTop:30, }}>
                        <Text>Folio Nº DP{curso.folio}/{curso.fecha_actual?curso.fecha_actual.substring(6,10):''}</Text>
                        <Text>FECHA DE EMISIÓN: {curso.fecha_actual}</Text>
                    </View>
                    
                </View> 
            </Page>
        </Document>
    )
}
// Create styles
const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 65,
        paddingHorizontal: 85,
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    encabezado: {
        position: 'absolute',
        fontSize: 10,
        //bottom: 30,
        paddingHorizontal: 20,
        //paddingTop:75,
        left: 0,
        right: 0,
        margin:20,
        textAlign: 'right',
        color: '#bf4e14',
      },
      parrafoTitulo:{
        marginTop: 35,
        fontFamily: 'Arimo',
        fontSize: 16,
        textAlign: 'justify'
    },
      parrafo:{
        marginTop: 25,
        fontFamily: 'Arimo',
        fontSize: 18,
        textAlign: 'left',

    },
    nombre:{
        fontFamily: 'Arimo',
        fontWeight: 'bold',
        textAlign: 'center',
        paddingTop: 25,
    },
    nombreCurso:{
        paddingTop: 25,
        fontFamily: 'Arimo',
        fontWeight: 'bold',
        textAlign: 'center',
        marginLeft: 10,
    },
    titulo:{
        fontFamily: 'Helvetica-Bold',
        fontSize: 26,
        textAlign: 'center'
    },
    fondo:{
        paddingLeft:1,
        width:"613px",
        height:"794px",
    },
    alumno:{
        margin: 20,
        fontFamily: 'Helvetica-Bold',
        fontSize: 24,
        textAlign: 'center',
        color:'rgb(245,145,11)'
    },
    curso:{
        margin: 20,
        fontFamily: 'Helvetica-Bold',
        fontSize: 22,
        textAlign: 'center',
        color:'rgb(245,145,11)'
    },
    firmas:{
        marginTop:20,
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
    },
    nombreFirma:{
        fontFamily: 'Helvetica-Bold',
        //fontWeight: 'bold',
        fontSize: 13,
    },
    cargoFirma:{
        fontFamily: 'Helvetica',
        //fontWeight: 'bold',
        fontSize: 13,
    },
    firmasNombre:{
        marginTop:25,
        fontFamily: 'Helvetica',
        fontSize: 14,
        textAlign: 'center',
        flexDirection:'row',
        justifyContent:'space-between',
    },
    firmasCargo:{
        fontFamily: 'Helvetica',
        fontSize: 14,
        textAlign: 'center',
        flexDirection:'row',
        justifyContent:'space-between',
    },
    textoIzquierda:{
        textAlign:'left',
    },
    textoDerecha:{
        textAlign:'right',
    },
    header: {
        position: 'absolute',
        marginBottom: 20,
      },
    piePagina: {
        position: 'absolute',
        fontSize: 6,
        bottom: 30,
        left: 0,
        right: 0,
        marginTop:40,
        marginLeft:40,
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'center',
    },
    piePaginaLogo:{ 
        position: 'absolute',
        fontSize: 6,
        bottom: 30,
        left: 0,
        right: 0,
        //marginRight:40,
        //flex: 0.5, 
        flexDirection: 'column', 
        justifyContent: 'space-between', 
        alignItems: 'right', 
    },
  });

export default EgresoPracticaPDF
